import { combineReducers } from 'redux';
import { apiReducer } from '../api/api-redux';

import { contextReducer } from './context-redux';

const rootReducer = combineReducers({
  api: apiReducer,
  context: contextReducer,
});

export default rootReducer;
